import BasePropertyView from 'BasePropertyView.js';
import _template from  'behaviors/properties/main/title.ejs';
import undoService from 'UndoService.js';
import textConstants from "../../../../constants/TextConstants";
import constants from "Constants.js";
import eventBus from 'EventBus.js';
import util from 'util/Util.js';


class MainTitleView extends BasePropertyView {
    initialize(opts){
        super.initialize(opts);
        this.template = _template;
        if(!this.model.has('title')){
            this.model.set('title', '', {silent:true});
        }
        this.events = {
            'change .title': 'changeTitle',
            'blur input[type=text]'    : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };
        this.listenTo(this.model, 'change', this.render);
    }
    changeTitle(e){
        const oldTitle = this.model.get('title');
        const currentTitle = util.sanitizeHTML(e.currentTarget.value, true, oldTitle);
        this.model.set('title', currentTitle, {silent:true});
        this.render();
        undoService.add({
            undo:()=>{
                this.model.set('title',oldTitle,{silent:true});
                eventBus.trigger(constants.EV_BEHAVIOR_PROPERTY_CHANGED,this.model);

            },
            redo:()=>{
                this.model.set('title', currentTitle,{silent:true});
                eventBus.trigger(constants.EV_BEHAVIOR_PROPERTY_CHANGED,this.model);
            }
        },textConstants.UNDO_CHANGE_TITLE)
    }
    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
    }
}

export default MainTitleView;